import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { AttributeService } from 'src/app/main/dynamic/service/attribute.service';
import { SharedDataService } from 'src/app/service/shared-data.service';

@Component({
  selector: 'app-select-container',
  templateUrl: './select-container.component.html',
  styleUrls: ['./select-container.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(400)
      ]),
      transition(':leave',
        animate(200, style({opacity: 0})))
    ])
  ]
})
export class SelectContainerComponent extends ComponentBase implements OnInit {

  constructor(
    private attributeService: AttributeService, 
    private sharedDataService: SharedDataService) {
      super()
  }

  get selectedContentAttrs(): AttributeModel[] {
    let content = this.attribute.attributes
      .find(attr => attr.type.toLowerCase() == "content")

    if(content) {
      return content.attributes
    }

    return []
  }

  ngOnInit() {
  }

  getSelectElement(): AttributeModel {
    return this.attribute.attributes
      .find(attr => attr.type.toLowerCase() == "collection")
  }

  handleEvent(events: DynamicEvent[]) {
    events.forEach(e => this.processEvent(e))

    this.emitEvents(events.filter(e => !e.abortNext))
  }

  processEvent(event: DynamicEvent): void {
    if(!event.attribute) {
      return
    }

    let sharingType = event.attribute.options
        .find(opt => opt.key.toLowerCase() == "sharingtype" && opt.value);

    if(event.name == "shareData" && 
       event.attribute.value && sharingType &&
       sharingType.value.toLowerCase() == "ParentFieldType".toLowerCase()) {

      let parentDataKeyOpt = event.attribute.options
        .find(opt => opt.key.toLowerCase() == "ParentDataKey".toLowerCase() && opt.value);

      var parentKeyAttr = this.selectedContentAttrs.find(attr => 
        attr.options.some(opt => 
          opt.key.toLowerCase() == "sharedata" &&
          opt.value.toLowerCase() == "true") &&
        attr.options.some(opt => 
          opt.key.toLowerCase() == "SharedDataKey".toLowerCase() &&
          opt.value.toLowerCase() == parentDataKeyOpt.value.toLowerCase()))
      
      if(parentKeyAttr) {
        this.sharedDataService.setItem(
          parentKeyAttr.uid,
          { 
            uid: event.attribute.uid, 
            key: event.attribute.value, 
            value: event.attribute.value 
          },
          "items"
        );
      }

      event.abortNext = true
    }
  }

  onChangedSelect(events: DynamicEvent[]) {
    events.forEach(event => {
      if(event && event.attribute) {
        this.setContent(event.attribute);
      }
    })

    this.emitEvents(events.filter(e => !e.abortNext))
  }

  private setContent(selected: AttributeModel) {
    if(selected) {
      let contentAttr = selected.attributes
        .find(attr => attr.type.toLowerCase() == "content");

      if (contentAttr) {
        let contentCopy = this.attributeService.copy(contentAttr)
        
        let existingContent = this.attribute.attributes
          .find(attr => attr.type.toLowerCase() == "content")

        if(existingContent) {
          let contentIndex = this.attribute.attributes
            .indexOf(existingContent)
          this.attribute.attributes.splice(contentIndex)
        }

        this.attribute.attributes.push(contentCopy);
      }
    }
  }
}
